import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects to data-controller="sortable"
// Place on the tasks container. Enables drag-to-reorder and keeps
// hidden position fields in sync so the server saves the correct order.
export default class extends Controller {
  static targets = ["list"]

  connect() {
    const list = this.hasListTarget ? this.listTarget : this.element

    this.sortable = Sortable.create(list, {
      handle: ".drag-handle",
      animation: 150,
      ghostClass: "sortable-ghost",
      chosenClass: "sortable-chosen",
      onEnd: () => {
        this._updating = true
        this.updatePositions(list)
        this.element.dispatchEvent(new CustomEvent("tasks-changed", { bubbles: true }))
        this._updating = false
      }
    })

    // Update positions when tasks are added or removed by nested-tasks
    this._onTasksChanged = () => {
      if (this._updating) return
      setTimeout(() => this.updatePositions(list), 10)
    }
    this.element.addEventListener("tasks-changed", this._onTasksChanged)

    // Initialize positions on page load
    this.updatePositions(list)
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy()
    this.element.removeEventListener("tasks-changed", this._onTasksChanged)
  }

  updatePositions(list) {
    const container = list || (this.hasListTarget ? this.listTarget : this.element)
    const tasks = Array.from(container.querySelectorAll(".nested-task")).filter(t => {
      if (t.style.display === "none") return false
      const destroy = t.querySelector("input[name*='_destroy']")
      return !(destroy && destroy.value === "1")
    })
    tasks.forEach((task, i) => {
      const posField = task.querySelector("[data-position-field]")
      if (posField) posField.value = i + 1
    })
  }
}
